module.exports = __webpack_public_path__ + "src/assets/heatmap_on.png";